import React, { useState } from 'react';
import axios from 'axios';
import { useCurrency } from '../../context/CurrencyContext';

const DashboardTodayAction = ({
  todayAction,
  isOvercommitted,
  onReviewVisions,
  onActionDone,
  embedded = false,
}) => {
  const { formatAmount } = useCurrency();
  const [done, setDone] = useState(todayAction?.done_today || false);
  const [saving, setSaving] = useState(false);

  if (isOvercommitted) {
    return (
      <section className="mb-10" aria-label="Today's action">
        <h2 className="text-body font-medium text-ink mb-3">One thing to do today</h2>
        <p className="text-body text-ink-muted">
          Fix your overcommitment first.{' '}
          <button
            type="button"
            onClick={onReviewVisions}
            className="text-pine underline underline-offset-2"
          >
            Review Visions →
          </button>
        </p>
      </section>
    );
  }

  if (!todayAction?.text) return null;

  const handleDone = async () => {
    setSaving(true);
    try {
      await axios.post('/api/dashboard/today-action/done', {
        action_id: todayAction.action_id,
        text: todayAction.text,
      });
      setDone(true);
      onActionDone?.();
    } catch (e) {
      console.error('Failed to mark action done:', e);
    } finally {
      setSaving(false);
    }
  };

  const surplus = todayAction.surplus;
  const visionName = todayAction.top_vision_name;

  return (
    <section className={embedded ? 'bento-card bento-card--compact' : 'mb-10'} aria-label="Today's action">
      <h2 className="text-body font-medium text-primary mb-3">One thing to do today</h2>
      <div className="border-l-4 border-pine pl-4 py-3">
        {done ? (
          <p className="text-body text-pine font-medium">✓ Done for today</p>
        ) : (
          <>
            <p className="text-body text-primary mb-2">{todayAction.text}</p>
            <p className="text-label text-secondary mb-3">
              Takes {todayAction.estimated_minutes || 2} minutes
            </p>
            <button
              type="button"
              onClick={handleDone}
              disabled={saving}
              className="btn-secondary text-sm py-1.5 px-4 disabled:opacity-50"
            >
              {saving ? 'Saving…' : 'Done'}
            </button>
          </>
        )}
      </div>
      {surplus != null && (
        <p className="text-label text-secondary mt-3">
          Based on your {formatAmount(surplus, { maximumFractionDigits: 0 })} surplus
          {visionName ? ` and ${visionName} goal` : ''}
        </p>
      )}
    </section>
  );
};

export default DashboardTodayAction;
